import {useMutation} from '@apollo/react-hooks';

import type {
    RemoveAccountForLead as RemoveAccountForLeadMutation,
    RemoveAccountForLeadVariables as RemoveAccountForLeadMutationVariables,
    LeadRemoveAccountInput,
} from 'nutshell-graphql-types';

import REMOVE_ACCOUNT_FOR_LEAD from '../mutations/remove-account-for-lead.graphql';

export function useRemoveAccountForLead(): {
    removeAccount: (input: LeadRemoveAccountInput) => Promise<any>;
    isLoading: boolean;
} {
    const [leadRemoveAccount, {loading}] = useMutation<
        RemoveAccountForLeadMutation,
        RemoveAccountForLeadMutationVariables
    >(REMOVE_ACCOUNT_FOR_LEAD);

    return {
        removeAccount: (input: LeadRemoveAccountInput) => {
            return leadRemoveAccount({
                variables: {input},
            });
        },
        isLoading: loading,
    };
}
